import type {z} from "zod";

import {ListSuppliersQueryParams} from "@project/sdk/engineering/zod";

export const listSuppliersSearchSchema = ListSuppliersQueryParams.extend({
  page: ListSuppliersQueryParams.shape.page.catch(1).default(1),
  perPage: ListSuppliersQueryParams.shape.perPage.catch(20).default(20),
  q: ListSuppliersQueryParams.shape.q.catch(undefined),
  state: ListSuppliersQueryParams.shape.state.catch("ACTIVE"),
  status: ListSuppliersQueryParams.shape.status.catch(undefined),
  role: ListSuppliersQueryParams.shape.role.catch(undefined),
  functionId: ListSuppliersQueryParams.shape.functionId.catch(undefined),
  standardization: ListSuppliersQueryParams.shape.standardization.catch(undefined),
  sortKey: ListSuppliersQueryParams.shape.sortKey.catch("supplierId"),
  sortDir: ListSuppliersQueryParams.shape.sortDir.catch("asc").default("asc"),
});

export type ListSuppliersSearchInput = z.input<typeof listSuppliersSearchSchema>;
export type ListSuppliersSearch = z.output<typeof listSuppliersSearchSchema>;
